import { render, staticRenderFns } from "./DealerCarousel.vue?vue&type=template&id=79073df4"
import script from "./DealerCarousel.vue?vue&type=script&lang=js"
export * from "./DealerCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports